// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"411":"15789ccd28621ad1","2665":"61845ed33d7af66b","3877":"fe336940f98fdfab","6803":"5ff503c492536d15","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};